import React from 'react';
import { ATMHeader, ATMSegment } from 'shared-it-appmod-ui';
import Lang from 'src/libraries/language';
import { IRequest } from 'src/models/request.model';
import FlightRequestAccounting from '../flight-request-accounting/flight-request-accounting.component';
import FlightRequestConstructionContractor from '../flight-request-construction-contractor/flight-request-construction-contractor.component';
import FlightRequestConstruction from '../flight-request-construction/flight-request-construction.component';
import FlightRequestDate from '../flight-request-date/flight-request-date.component';
import FlightRequestPatrolPassengerContractor from '../flight-request-patrol-passenger-contractor/flight-request-patrol-passenger-contractor.component';
import FlightRequestPatrolPassenger from '../flight-request-patrol-passenger/flight-request-patrol-passenger.component';
import FlightRequestRequestor from '../flight-request-requestor/flight-request-requestor.component';
import FlightRequestDroneSDGEReviewComponent from '../flight-request-drone/flight-request-drone-sdge/flight-request-drone-sdge-review.component';
import FlightRequestDroneContractorReviewComponent from '../flight-request-drone/flight-request-drone-contractor/flight-request-drone-contractor-review.component';
import FlightRequestEmergencyPoc from '../flight-request-emergency-poc/flight-request-emergency-poc.component';

type IProps = {
  data: IRequest;
};

const FlightRequestReviewView: React.FC<IProps> = ({ data }) => {
  return (
    <>
      <FlightRequestRequestor data={data} />
      <FlightRequestEmergencyPoc data={data} />
      <FlightRequestDate data={data} />
      <FlightRequestAccounting data={data} />

      <ATMSegment>
        <ATMHeader>{Lang.TTL_REQUEST_FLIGHT_INFORMATION}</ATMHeader>
        {data.passengerFlight && <FlightRequestPatrolPassenger data={data} />}
        {data.passengerContractorFlight && (
          <FlightRequestPatrolPassengerContractor data={data} />
        )}
        {data.constructionFlight && <FlightRequestConstruction data={data} />}
        {data.constructionContractorFlight && (
          <FlightRequestConstructionContractor data={data} />
        )}
        {data.droneFlightContractor && (
          <FlightRequestDroneContractorReviewComponent data={data} />
        )}
        {data.droneFlightSDGE && (
          <FlightRequestDroneSDGEReviewComponent data={data} />
        )}
      </ATMSegment>
    </>
  );
};

export default FlightRequestReviewView;
